module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEjSURBVHgBrZXRjcIwEEQnUf6PDs5XwXEVHFQAHRAqADpwOoAKgA5CBUAFhAoIHYQKwixxkBF8kA1PmnhjaUdrW14HSZJMyrK0AApqjGb8U1Mqp/oRjeTnj+pSIzTjTP1QcyqOXEXGWptyTKGAuVJIGqJa2pITHShgXszhIMWE/GSo1tyFjgmVSBC5iT01orFBc2SLct9MkGUatIXOK2oIBcw71fsdelUV0FG4/LvZF/Q8mQk5dFxemWm5b88nzPBJs+9XZqrr5FObnVua5b6ZYKDDwB1C5DkPlHezw7wHM3im7ZBe1PJuGolDF/y6Tqthjaqn3Q5gS82ghEVYDj0OvXrPMvlBwwclCIKMD9KG4ZEyYragTtTOxW+3IhrFqF6mnegKaYJhRWeMiP4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/inner-box.png
// module id = 93
// module chunks = 1